import { render, staticRenderFns } from "./UnlockedIcon.vue?vue&type=template&id=8bbea5d2&"
import script from "./UnlockedIcon.vue?vue&type=script&lang=js&"
export * from "./UnlockedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports